import { Dialog, makeStyles, useMediaQuery, DialogContent, useTheme, DialogTitle, Typography, Button, DialogActions } from '@material-ui/core';
import { openChatState, SUPPORT_CHAT } from 'pages/CustomerBooking';
import { highlightActionState } from 'pages/CustomerBooking/RecoilState';
import React, { useEffect, useMemo, useState } from 'react';
import Lottie from 'react-lottie-player';
import { Link as RouterLink } from 'react-router-dom'
import { useSetRecoilState } from 'recoil';
import { useTrackEvent, useTrackPage } from 'util/trackEvent';

import animationData from "src/pages/ActionLayout/Finalize/anim_completion.json";

const useStyles = makeStyles((theme) => {
  return {
    root: {
      alignSelf: 'center',
      textAlign: 'center',
    },
    lottie: {
      height: 200
    },
    content: {
      lineHeight: '2em',
      padding: theme.spacing(3)
    },
    actions: {
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'wrap',
      justifyContent: 'center',
      "&>*": {
        width: '80%',
        marginBottom: theme.spacing(2)
      },

    }
  }
})
const BookingTimeoutPopup = ({ open = false, confirmed = false, serviceId }) => {
  const classes = useStyles()

  const [isOpen, setIsOpen] = useState(true);
  const setChatOpen = useSetRecoilState(openChatState);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const trackEvent = useTrackEvent()
  const setHighlightActionState = useSetRecoilState(highlightActionState);
  return (
    <Dialog open={isOpen} maxWidth="xs"  >
      <DialogContent className={classes.root}>
        <Typography variant='h4'>
          Your booking has timed out
        </Typography>
        <Typography variant='body1' className={classes.content}>
          {confirmed ?
            <>Unfortunately there is no provider available at your preferred time.<br />Please reschedule your booking in the next page.</>
            : <>It looks like you weren’t able to confirm your booking in time. <br />Please reschedule your booking in the next page.</>
          }
        </Typography>
        <DialogActions className={classes.actions}>

          <Button 
            // component={RouterLink}
            // to={`/bookings/${serviceId}/rebooking`}
            variant='contained' size="large" color='primary' onClick={() => {
              trackEvent('Timeout dialog - Okay ', { dialog: 'BookingTimeoutPopup' })
              setIsOpen(false)
              setHighlightActionState(true)
            }}>Okay</Button>
          <Button variant='text' size="large" color='primary' onClick={() => {
            trackEvent('Timeout dialog - Contact Support ', { dialog: 'BookingTimeoutPopup' })
            setIsOpen(false)
            setChatOpen(SUPPORT_CHAT)
          }}>Contact Support</Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  )
}

export { BookingTimeoutPopup }